import Logo from '../logos/thewasim';

export default Logo;
